<template>
  <main
    class="relative flex w-full h-screen max-h-screen bg-ewhite-50 overflow-hidden"
  >
    <DashboardNavigation class="z-50"></DashboardNavigation>

    <section
      class="relative flex-1 min-w-0 z-10 bg-gradient-to-br from-ewhite-50 via-white to-ewhite-100/60"
    >
      <router-view></router-view>
    </section>
    <!-- Chatbot Widget (admin only) -->
    <ChatWidget v-if="canUseAiAssistant" />
    <svg
      viewBox="0 0 2 1"
      preserveAspectRatio="none"
      class="absolute bottom-0 left-0 z-0 w-full h-32"
    >
      <defs>
        <path
          id="w"
          d="
                m0 1v-.5 
                q.5.5 1 0
                t1 0 1 0 1 0
                v.5z"
        />
      </defs>
      <g>
        <use href="#w" y=".0" fill="#fac9ae" />
        <use href="#w" y=".1" fill="#f3764a" />
        <use href="#w" y=".2" fill="#f7a27a" />
      </g>
    </svg>
  </main>
</template>

<script>
import DashboardNavigation from "./components/DashboardNavigation.vue";
import { ChatWidget } from "@domains/chatbot";
import { appAbility } from "@/domains/auth";
import { useFeatureFlagStore } from "@/domains/feature-flags";
import { FEATURE_FLAGS } from "@/constants/feature-flags";

export default {
  name: "DashboardIndex",
  components: {
    DashboardNavigation,
    ChatWidget,
  },
  data() {
    return {
      abilityVersion: 0,
      stopAbilityListener: null,
    };
  },
  mounted() {
    this.stopAbilityListener = appAbility.on("updated", () => {
      this.abilityVersion += 1;
    });
  },
  beforeUnmount() {
    if (this.stopAbilityListener) {
      this.stopAbilityListener();
    }
  },
  computed: {
    canUseAiAssistant() {
      void this.abilityVersion;
      const hasAbility =
        appAbility.can("manage", "all") ||
        appAbility.can("read", "AIAssistant") ||
        appAbility.can("create", "AIAssistant");

      return (
        hasAbility &&
        useFeatureFlagStore().isRuntimeEnabled(FEATURE_FLAGS.AI_ASSISTANT)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
use {
  animation: move-forever 7s linear infinite;
  &:nth-child(2) {
    animation-duration: 4;
    animation-delay: -1.5s;
  }
  &:nth-child(1) {
    animation-duration: 10s;
  }
}

@keyframes move-forever {
  0% {
    transform: translate(-2px, 0);
  }
  100% {
    transform: translate(0px, 0);
  }
}
</style>
